import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=529a764b&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=529a764b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a764b",
  null
  
)

export default component.exports